export const GoogleDriveIcon = ({ size = 12 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Google Drive"
    role="img"
    width={size}
    height={size}
    viewBox="0 0 512 512">
    <path d="m126 417q9 5 19 5H367q9 0 19-5V313H99" fill="#4285f4" />
    <path d="m196 87q9-5 20-5h80q12 0 20 5v104h-68" fill="#188038" />
    <path d="m66 313q0-10 5-19l110-191q6-11 15-16l60 104-72 125" fill="#34a853" />
    <path d="M316 87q10 6 15 16L438 289q8 12 8 24l-118 3-72-125" fill="#fbbc04" />
    <path d="m185.714 313H66q0 8 3 15l40 70q7 13 17 19" fill="#1967d2" />
    <path d="m386 417q9-5 16-17l38-66q6-10 6-21H326.3" fill="#ea4335" />
  </svg>
);
